export const LIMIT_500 = 500;
export const AUTHOR_BLOGS_PAGE_SIZE = 9;
export const DEFAULT_LANGUAGE_ID = '1';
export const DEFAULT_CONHOST_ID = process.env.NEXT_PUBLIC_DOTCMS_SITE_ID;
export const FEATURE_GRID_IDENTIFIER = 'b13e3269ff86914077843993bf11e0bf';
